/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { SortOrder } from '../models/SortOrder';
import { SourceAccountSortField } from '../models/SourceAccountSortField';

/**
* List of sorting options. Sorting is applied in the order passed in the list. 
*/
export class SortSourceAccountsBy {
  'field': SourceAccountSortField;
  'order': SortOrder;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "field",
      "baseName": "field",
      "type": "SourceAccountSortField",
      "format": ""
    },
    {
      "name": "order",
      "baseName": "order",
      "type": "SortOrder",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return SortSourceAccountsBy.attributeTypeMap;
  }

  public constructor() {
  }
}



